import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "internal-page-link mb-4" }
const _hoisted_2 = { class: "selector" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "page-selector me-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "mas me-1" }, "search", -1)
const _hoisted_6 = { class: "linked-page-name d-flex align-items-center" }
const _hoisted_7 = { class: "d-flex justify-content-center align-items-center border border-1 rounded fst-italic px-3 py-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "close", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "preview"
}
const _hoisted_11 = {
  key: 0,
  class: "d-flex align-items-center text-danger mt-3"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "mas me-2" }, "error", -1)
const _hoisted_13 = {
  key: 1,
  class: "d-flex align-items-center text-warning mt-3"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "mas me-2" }, "warning", -1)
const _hoisted_15 = { class: "card-title" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "card-text fst-italic" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal_button = _resolveComponent("base-modal-button")!
  const _component_CpAbstractsOverview = _resolveComponent("CpAbstractsOverview")!
  const _component_base_modal = _resolveComponent("base-modal")!
  const _component_base_card_image = _resolveComponent("base-card-image")!
  const _component_base_card_body = _resolveComponent("base-card-body")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_base_modal_button, {
            class: "btn btn-icon btn-sm btn-warning",
            "modal-id": _ctx.modalId
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(_toDisplayString(_ctx.$t('select') + ' ' + _ctx.$t('page').toLowerCase()), 1)
            ]),
            _: 1
          }, 8, ["modal-id"]),
          _createVNode(_component_base_modal, {
            "modal-id": _ctx.modalId,
            "dialog-classes": "modal-xl modal-dialog-scrollable",
            title: "Content pages"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CpAbstractsOverview, {
                onExceptions: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('exceptions'))),
                onSelectedCp: _ctx.setPageId
              }, null, 8, ["onSelectedCp"])
            ]),
            _: 1
          }, 8, ["modal-id"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString((_ctx.linkedPageName) ? _ctx.linkedPageName : _ctx.$t('noPageSelected')), 1),
          (_ctx.hasInternalPageLink)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearPageId && _ctx.clearPageId(...args)), ["prevent"])),
                class: "btn btn-icon btn-sm ms-1"
              }, _hoisted_9))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.hasInternalPageLink)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_ctx.isDeleted)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                _hoisted_12,
                _createTextVNode(_toDisplayString(_ctx.$t('linkedPageDeleted')), 1)
              ]))
            : (_ctx.isNotPublished)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                  _hoisted_14,
                  _createTextVNode(_toDisplayString(_ctx.$t('linkedPageNotPublished')), 1)
                ]))
              : _createCommentVNode("", true),
          _createVNode(_component_base_card, { class: "flex-row align-items-start mt-3" }, {
            default: _withCtx(() => [
              (_ctx.hasLinkedPageOverview)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (this.linkedPageOverview?.image_url)
                      ? (_openBlock(), _createBlock(_component_base_card_image, {
                          key: 0,
                          src: this.linkedPageOverview.image_url,
                          style: {"padding":"1rem 0 1rem 1rem","height":"auto","max-width":"calc(30% - 1rem)"}
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_base_card_body, null, {
                      default: _withCtx(() => [
                        _createElementVNode("h5", _hoisted_15, _toDisplayString(_ctx.linkedPageOverview.title), 1),
                        (_ctx.linkedPageOverview.content)
                          ? (_openBlock(), _createElementBlock("p", {
                              key: 0,
                              innerHTML: _ctx.previewContent,
                              class: "card-text"
                            }, null, 8, _hoisted_16))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ], 64))
                : (_openBlock(), _createBlock(_component_base_card_body, { key: 1 }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('noPreview')), 1)
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}